
<script>
const markdownFiles = require.context("./posts/", false, /\.md$/);

export default {
  name: "MarkdownBlogs",
  created() {
    this.loadPosts();
  },
  methods: {
    async loadPosts() {
      const files = markdownFiles.keys();
      const posts = await Promise.all(
          files.map(async (file) => {
            const slug = file.replace("./", "").replace(".md", "");
            const content = await import(`./posts/${slug}.md`);
            const { data: metadata, content: body } = this.parseFrontmatter(
                content.default
            );
            return {
              slug,
              title: metadata.title || this.extractTitle(body),
              excerpt: metadata.excerpt || body.substring(0, 100),
              date: metadata.date,
              author: metadata.author,
              tags: metadata.tags,
              content: body,
            };
          })
      );
      const sortedPostsByDate = posts.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
      );
      this.posts = sortedPostsByDate;
    },
    extractTitle(markdown) {
      const match = markdown.match(/^# (.+)/);
      return match ? match[1] : "Untitled";
    },
    parseFrontmatter(markdown) {
      const frontmatterRegex = /^---\n([\s\S]+?)\n---\n([\s\S]*)$/;
      const match = markdown.match(frontmatterRegex);
      if (match) {
        const metadata = match[1].split("\n").reduce((acc, line) => {
          const [key, value] = line.split(":").map((str) => str.trim());
          if (key && value) acc[key] = value;
          return acc;
        }, {});
        return { data: metadata, content: match[2] };
      }
      return { data: {}, content: markdown };
    },
    sanitize(input) {
      const div = document.createElement("div");
      div.textContent = input;
      return div.innerHTML;
    },
  },
  data() {
    return {
      posts: [],
    };
  },
};
</script>

<template>
  <div>
    <div class="columns is-multiline is-centered">
      <div
        class="column is-12-mobile is-6-tablet is-4-desktop"
        v-for="post in posts"
        :key="post.slug"
        v-if="new Date(post.date).toISOString() <= new Date().toISOString()"
      >
        <div class="blog-card">
        <router-link :to="`/blog/post/${post.slug}`" class="blog-card-link">
          <span class="blog-card-date">
            {{ new Date(post.date).toDateString() }}</span
          >
          <h2 class="blog-card-title">{{ post.title }}</h2>
          <p class="blog-card-excerpt">{{ post.excerpt }}</p>
          <div class="blog-card-metadata">
            <div class="blog-card-tags">
              <b-tag
                v-for="tag in JSON.parse(post.tags)"
                :key="tag"
                class="blog-card-tag"
                type="is-info"
                size="is-small"
                :closable="false"
                >{{ tag }}</b-tag
              >
            </div>
          </div>
        </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.blog-card-tag {
  margin: 0 0.25rem;
}
.blog-card {
  background-color: var(--card-bg-color, #ffffff);
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin: 0.2rem;
  height: 100%;
}
.blog-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

.blog-card-link {
  text-decoration: none;
  color: inherit;
  display: block;
  padding: 1.5rem;
}

.blog-card-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: var(--primary-text-color, #333333);
  text-align: center;
}

.blog-card-excerpt {
  font-size: 1rem;
  color: var(--secondary-text-color, #666666);
  line-height: 1.5;
}
</style>
